import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProviderProps } from 'react-oidc-context';

import { getOidcConfig } from 'networking/api-config';

export const getAuthProviderConfig = (): AuthProviderProps => {
  const oidcConfig = getOidcConfig();

  return {
    authority: oidcConfig.authority,
    automaticSilentRenew: true,
    client_id: oidcConfig.clientId,
    onSigninCallback: () => {
      globalThis.history.replaceState(
        {},
        globalThis.document.title,
        globalThis.location.pathname
      );
    },
    post_logout_redirect_uri: oidcConfig.postLogoutRedirectUri,
    redirect_uri: oidcConfig.redirectUri,
    scope: oidcConfig.scope,
    userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
  };
};
